import React from 'react'
import PropTypes from 'prop-types'

import StatusIndicator from './StatusIndicator'
import CardReaderConnected from './CardReaderConnected'
import CardReaderDisconnected from './CardReaderDisconnected'

const CardReaderIndicator = ({ available, className, ...props }) => {
  let icon = <CardReaderDisconnected />

  if (available) {
    icon = <CardReaderConnected />
  }

  return <StatusIndicator {...props} className={className} icon={icon} available={available} text="card reader" />
}

CardReaderIndicator.defaultProps = {
  available: false,
}

CardReaderIndicator.propTypes = {
  available: PropTypes.bool,
}

export default CardReaderIndicator
